export default "__VITE_ASSET__zaD8X4Fb__"